/**
 * StepByStepHeader
 * TODO: Heading is rendering a bit different
 */
import React from 'react';
import clsx from 'clsx';
var StepByStepHeader = function (_a) {
    var header = _a.header, subHeader = _a.subHeader, number = _a.number, listType = _a.listType, id = _a.id, children = _a.children, _b = _a.lastChild, lastChild = _b === void 0 ? false : _b;
    return (React.createElement("div", { className: clsx('relative mt-8 mb-6 border-b-2 border-greyLight', listType === 'numbers' && 'pb-8'), "data-cid": "StepByStepHeader" },
        React.createElement("div", { className: clsx(listType === 'numbers' && '-ml-20', 'flex', lastChild &&
                'stepbystep__heading-wrapper--last stepbystep__heading-wrapper--last--is-header') },
            listType === 'numbers' && (React.createElement("span", { className: "border-primary-theme text-primary-theme flex items-center justify-center flex-shrink-0 w-10 h-10 mr-7 ml-3 font-bold bg-white border-3 rounded-full step-by-step__number" }, number)),
            React.createElement("h2", { className: clsx('text-h2 font-semibold flex justify-between w-full stepbystep__heading mb-4', listType === 'numbers' &&
                    'font-bold stepbystep__heading--number text-primary-theme'), id: id },
                header,
                subHeader && React.createElement("span", { className: "text-h3" }, subHeader))),
        React.createElement("div", null, children)));
};
export default StepByStepHeader;
